import { render, staticRenderFns } from "./HorizontalTextImageSection.vue?vue&type=template&id=7908405c&scoped=true&"
import script from "./HorizontalTextImageSection.vue?vue&type=script&lang=js&"
export * from "./HorizontalTextImageSection.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTextImageSection.vue?vue&type=style&index=0&id=7908405c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908405c",
  null
  
)

export default component.exports